<template>
    <div class="bg-light" style="height: 100vh">
        <b-container class="pb-12">
            <b-row class="justify-content-center">
                <b-col>
                    <b-card bg-variant="secondary" class="border-0 mt-2">
                        <b-card-header header-class="text-center  mb-4">
                            <h1 class="display-1">OMS</h1>
                        </b-card-header>
                        <b-card-body class="px-lg-5 py-lg-1">
                            <b-form
                                class="text-center"
                                v-if="validOrder && !postedOrder"
                            >
                                <p>{{ 'Ref:' + order.id }}</p>

                                <p>{{ 'Customer:' + order.customer.name }}</p>

                                <p
                                    align="center"
                                    style="
                                        font-size: 20px;
                                        font-family: Helvetica, Arial,
                                            sans-serif;
                                        color: #333333;
                                    "
                                    class="padding-copy"
                                >
                                    Order Acknowledgement
                                </p>

                                <p>
                                    Check the box below to acknowledge that the
                                    order was completed<b-checkbox
                                        v-model="feedback.completed"
                                    ></b-checkbox>
                                </p>

                                <b-form-group
                                    id="fieldset-comments"
                                    label="Optional Comments:"
                                    label-for="comment"
                                >
                                    <b-form-textarea
                                        id="comment"
                                        v-model="feedback.comments"
                                        placeholder="Enter something..."
                                        rows="5"
                                        max-rows="6"
                                    ></b-form-textarea>
                                </b-form-group>

                                <div>
                                    <p
                                        align="center"
                                        style="
                                            font-size: 20px;
                                            font-family: Helvetica, Arial,
                                                sans-serif;
                                            color: #333333;
                                        "
                                        class="padding-copy"
                                    >
                                        Feedback Question
                                    </p>

                                    <p>
                                        On a scale of 1 to 5 being the highest
                                        how do you rate this service delivered
                                    </p>

                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            id="rating"
                                            v-model="feedback.rating"
                                            :options="[1, 2, 3, 4, 5]"
                                            :aria-describedby="ariaDescribedby"
                                            name="rating"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div class="text-center mb-6">
                                    <b-button
                                        :disabled="!feedback.completed"
                                        class="my-4"
                                        variant="primary"
                                        @click="submitCompleted"
                                        >{{
                                            submitting
                                                ? 'Submitting..'
                                                : 'Submit'
                                        }}</b-button
                                    >
                                </div>
                            </b-form>

                            <div class="text-center mb-4" v-else>
                                <p>{{ staticMessage }}</p>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import api from '@/api/auth'
export default {
    name: 'CustomerFeedback',
    data() {
        return {
            submitting: false,
            order: {
                customer: {},
            },
            postedOrder: false,
            feedback: {},
            loading: true,
        }
    },
    computed: {
        validOrder() {
            return !!this.order.id
        },
        staticMessage() {
            //validOrder && postedOrder || loading
            if (this.postedOrder) return 'Thank You. Your Order is completed'
            if (this.loading) return 'Loading Page......'
            if (!this.validOrder) return 'Expired or Invalid Link'
            return ''
        },
    },
    watch: {},
    async mounted() {
        this.order_id = this.$route.query.order_id
        this.hash = this.$route.query.hash
        this.timestamp = this.$route.query.timestamp
        try {
            const resp = await api.getOrderData({
                order_id: this.order_id,
                hash: this.hash,
                timestamp: this.timestamp,
            })
            console.log('getOrderData resp', resp)
            this.order = resp.data.success.data
        } catch (err) {
            console.error('getOrderData', err)
        } finally {
            this.loading = false
        }
    },
    methods: {
        async submitCompleted() {
            this.submitting = true
            let req = {
                order_id: this.order_id,
                hash: this.hash,
                timestamp: this.timestamp,
            }
            req = { ...req, ...this.feedback }
            req.comments = req.comments || '-'
            console.log('submit data', req)
            try {
                const resp = await api.postOrderCompleted(req)
                console.log('submit resp', resp)
                this.submitting = false
                this.postedOrder = true
            } catch (err) {
                this.submitting = false
                console.error('submitCompleted', err)
            }
        },
    },
}
</script>
<style>
</style>
